import React from "react";
import { Dialog, DialogContent, Typography, Stack, Box } from "@mui/material";
import ContainedButton from "../../forms/button/ContainedButton";
import { UnifiedIcon } from "../Icon/UnifiedIcon";
import { IoHelpCircle } from "react-icons/io5";

interface ResumeSessionModalProps {
  open: boolean;
  onResume: () => void;
  onStartFresh: () => void;
}

const ResumeSessionModal: React.FC<ResumeSessionModalProps> = ({
  open,
  onResume,
  onStartFresh,
}) => {
  return (
    <Dialog
      open={open}
      maxWidth="xs"
      fullWidth
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "16px",
          padding: "20px",
          textAlign: "center",
        },
        zIndex: 2000,
      }}
    >
      <DialogContent>
        <Stack spacing={2} alignItems="center">
          <Box sx={{ mb: 1 }}>
            <UnifiedIcon icon={IoHelpCircle} fontSize={60} color="#1064ED" />
          </Box>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              color: "#1064ED",
              fontFamily: "Figtree",
            }}
          >
            Resume Previous Session?
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "#666",
              fontFamily: "Figtree",
              mb: 2,
            }}
          >
            We found data from a previous session. Would you like to resume?
          </Typography>
          <Stack direction="row" spacing={2} sx={{ width: "100%" }}>
            <ContainedButton
              label="No, Start Fresh"
              onClick={onStartFresh}
              bgColor={"#f44336"} // Hardcoded red color for "No"
              hoverColor={"#d32f2f"}
              sx={{
                width: "100%",
                fontWeight: 600,
                color: "#ffffff",
                "&:hover": {
                  backgroundColor: "#d32f2f",
                },
              }}
            />
            <ContainedButton
              label="Yes, Resume"
              onClick={onResume}
              sx={{
                width: "100%",
                fontWeight: 600,
                color: "#ffffff",
                backgroundColor: "#1064ED",
                "&:hover": {
                  backgroundColor: "#0d52c1",
                },
              }}
            />
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default ResumeSessionModal;
